import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-permission-guide-dialog',
  templateUrl: './notification-permission-guide-dialog.component.html',
  styleUrls: ['./notification-permission-guide-dialog.component.scss']
})
export class NotificationPermissionGuideDialogComponent implements OnInit, OnDestroy {
  public showDeniedHint = false;
  public currentHost = '';
  public isSafari = false;

  private currentPermission: NotificationPermission | 'unsupported' = 'default';
  private permissionStatusRef: any = null;
  private permissionPollId: any = null;
  private permissionChangeHandler = () => this.handlePermissionChange();
  private readonly pollIntervalMs = 1500;
  private destroyed = false;

  constructor(
    private dialogRef: MatDialogRef<NotificationPermissionGuideDialogComponent>
  ) { }

  ngOnInit(): void {
    this.isSafari = this.detectSafari();
    this.currentHost = this.resolveCurrentHost();
    this.currentPermission = this.readPermission();
    this.startPermissionListener();
    this.startPermissionPolling();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.stopPermissionListener();
    this.stopPermissionPolling();
  }

  public close(): void {
    this.dialogRef.close();
  }

  private resolveCurrentHost(): string {
    if (typeof window === 'undefined' || !window.location) return '';
    return window.location.host || window.location.hostname || '';
  }

  private detectSafari(): boolean {
    if (typeof navigator === 'undefined') return false;

    var ua = (navigator.userAgent || '').toLowerCase();
    var vendor = ((navigator as any).vendor || '').toLowerCase();

    return ua.indexOf('safari') !== -1 &&
      ua.indexOf('chrome') === -1 &&
      ua.indexOf('chromium') === -1 &&
      ua.indexOf('crios') === -1 &&
      ua.indexOf('fxios') === -1 &&
      ua.indexOf('edg') === -1 &&
      vendor.indexOf('apple') !== -1;
  }

  private readPermission(): NotificationPermission | 'unsupported' {
    if (typeof Notification === 'undefined') return 'unsupported';
    return Notification.permission;
  }

  private startPermissionListener(): void {
    if (typeof navigator === 'undefined') return;
    var perms = (navigator as any).permissions;
    if (!perms || typeof perms.query !== 'function') return;

    perms.query({ name: 'notifications' }).then(
      (status) => {
        if (this.destroyed) return;
        this.permissionStatusRef = status;
        this.permissionStatusRef.onchange = this.permissionChangeHandler;
      },
      () => {
        this.permissionStatusRef = null;
      }
    );
  }

  private stopPermissionListener(): void {
    if (this.permissionStatusRef) {
      this.permissionStatusRef.onchange = null;
      this.permissionStatusRef = null;
    }
  }

  private startPermissionPolling(): void {
    if (typeof window === 'undefined') return;
    this.permissionPollId = window.setInterval(
      () => this.handlePermissionChange(),
      this.pollIntervalMs
    );
  }

  private stopPermissionPolling(): void {
    if (this.permissionPollId) {
      clearInterval(this.permissionPollId);
      this.permissionPollId = null;
    }
  }

  private handlePermissionChange(): void {
    var next = this.readPermission();
    if (next === this.currentPermission) return;

    var previous = this.currentPermission;
    this.currentPermission = next;

    if (next === 'granted') {
      this.showDeniedHint = false;
      this.close();
      return;
    }

    if (next === 'denied' && previous !== 'denied') {
      this.showDeniedHint = true;
    } else if (next !== 'denied') {
      this.showDeniedHint = false;
    }
  }
}
